// extracted by mini-css-extract-plugin
export default {"hidden":"ContactEdit_hidden__WLjH2"};